import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { COMMITMENTS } from "../../data/portalDemo.js";
import { fetchDocuments, downloadUrl } from "../../lib/portalApi.js";

export default function PortalDocuments() {
  const [cat, setCat] = useState("All Documents");
  const [q, setQ] = useState("");
  const [docs, setDocs] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchDocuments()
      .then(d => { if (alive) setDocs(d); })
      .catch(e => { if (alive) setError(e.message); });
    return () => { alive = false; };
  }, []);

  const fundLabel = (slug) => {
    if (!slug) return "Cross-fund";
    return COMMITMENTS.find(c => c.slug === slug)?.fund || slug;
  };

  const categories = useMemo(() => {
    if (!docs) return ["All Documents"];
    const set = new Set(docs.map(d => d.type).filter(Boolean));
    return ["All Documents", ...Array.from(set).sort()];
  }, [docs]);

  const filtered = useMemo(() => {
    if (!docs) return [];
    let rows = docs.slice();
    if (cat !== "All Documents") rows = rows.filter(d => d.type === cat);
    if (q.trim()) {
      const needle = q.toLowerCase();
      rows = rows.filter(d => d.title.toLowerCase().includes(needle) || (d.deliveredBy || "").toLowerCase().includes(needle));
    }
    return rows;
  }, [docs, cat, q]);

  return (
    <div className="portal-page">
      <h1 className="portal-h1">Documents</h1>

      <div className="docs-toolbar">
        <input
          className="portal-input"
          placeholder="Search documents…"
          value={q}
          onChange={e => setQ(e.target.value)}
        />
      </div>

      <div className="docs-layout">
        <aside className="docs-rail">
          {categories.map(c => {
            const count = c === "All Documents" ? (docs?.length || 0) : (docs || []).filter(d => d.type === c).length;
            return (
              <button key={c}
                      className={"docs-rail-link" + (cat === c ? " active" : "")}
                      onClick={() => setCat(c)}>
                <span>{c}</span>
                <span className="docs-rail-count">{count}</span>
              </button>
            );
          })}
        </aside>

        <section className="docs-list portal-card">
          {error && (
            <p className="muted small" style={{ color: "var(--portal-neg)" }}>
              {error}
            </p>
          )}
          {!docs && !error && (
            <p className="muted small">Loading documents from Box…</p>
          )}
          {docs && (
            <div className="portal-table-wrap">
              <table className="portal-table">
                <thead>
                  <tr>
                    <th>Document</th>
                    <th>Fund</th>
                    <th>Type</th>
                    <th>Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map(d => (
                    <tr key={d.id}>
                      <td>{d.title}</td>
                      <td className="muted">
                        {d.fund
                          ? <Link className="portal-link" to={`/portal/funds/${d.fund}`}>{fundLabel(d.fund)}</Link>
                          : (d.fundLabel || "Cross-fund")}
                      </td>
                      <td className="muted">{d.type}</td>
                      <td className="muted">{d.date}</td>
                      <td><a className="portal-rowlink" href={downloadUrl(d.id)} target="_blank" rel="noopener noreferrer">Open</a></td>
                    </tr>
                  ))}
                  {!filtered.length && (
                    <tr><td colSpan={5} className="muted small">No documents match.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
        </section>
      </div>
    </div>
  );
}
